import React, { useState, useEffect, useRef } from 'react';
import * as XLSX from 'xlsx';

export const MSILChatBot = ({ BotIcon, MainIcon, ApiUrl, Token }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [mView, setMView] = useState(false);
  const [messages, setMessages] = useState([]);
  const [message, setMessage] = useState('');
  const [user, setUser] = useState(localStorage.getItem('userInfo'));
  const [userLetters, setUserLetters] = useState('U');
  const [kpiValue, setKpiValue] = useState('BO Trend');
  const [placeholderValue, setPlaceholderValue] = useState(
    'Type your message here....'
  );
  const [isAuthorizedUser, setIsAutherizedUser] = useState(true);

  const myScrollContainer = useRef(null);
  const isFirstMessageProcessed = useRef(false);

  //check for the token expiry and validation in between message sending
  const resetTheValidToken = () => {
    const newToken = localStorage.getItem(Token);
    const newUserInfo = localStorage.getItem('userInfo');

    if (newToken && newUserInfo) {
      // localStorage.setItem(Token, newToken);
      // localStorage.setItem("userInfo", newUserInfo);

      const newtokenResetMessage = {
        msgre: ' ',
        message: 'admin',
        action: false,
        time: calculateTime(),
        kpi: false,
        isAuthorizedUser: true,
      };

      setMessages((prevMessages) => [...prevMessages, newtokenResetMessage]);
      typingAnimation(
        `Your token and credentials are reset. you may continue now`,
        messages.length + 2
      );

      setIsAutherizedUser(true);
    }
  };

  //add first message as welcome message
  useEffect(() => {
    setPlaceholderValue(
      `Type your queries on ${kpiValue}, To change kpi type "Kpi" or "Hi"`
    );

    setUser(localStorage.getItem('userInfo'));

    setUserLetters(extractLettersOfName(JSON.parse(user).name));

    if (!isFirstMessageProcessed.current) {
      setIsLoading(true);
      const initialBotMessage = {
        msgre: '',
        message: 'admin',
        action: false,
        time: calculateTime().toString(),
        button: false,
        buttons: [],
        kpiValues: [
          { button: 'DI Adherence', buttonName: 'DI Adherence' },
          { button: 'Model Wise BO', buttonName: 'Model Wise BO' },
          { button: 'Warehouse Wise BO', buttonName: 'Warehouse Wise BO' },
          { button: 'Dealer Top 50', buttonName: 'Dealer Top 50' },
          { button: 'BO Trend', buttonName: 'BO Trend' },
          { button: 'BO Parts', buttonName: 'BO Parts' },
        ],
        kpi: true,
        isAuthorizedUser: true,
      };

      setMessages([initialBotMessage]);

      typingAnimation(
        `Hi! I am your GenAI Assistant for Spare Parts Back Order Analysis. I can help you with translating your English questions to SQL queries for fetching results from Database. Please let me know what can i help?. By default BO trend is Selected`,
        0
      );
      setIsLoading(false);
      isFirstMessageProcessed.current = true;
    }
    // eslint-disable-next-line
  }, []);

  //Always when Open scroll to bottom
  useEffect(() => {
    if (isOpen) {
      scrollToBottom();
    }
  }, [isOpen]);

  //when message added or modified scroll to bottom
  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  //check for changes in expanded view
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('view') === 'm') {
      setMView(true);
      setIsOpen(true);
      setIsButtonClicked(true);
    } else {
      setMView(false);
    }
  }, [mView, isOpen]);

  //extract the Firstname and Last Name first letters to create userIcon
  const extractLettersOfName = (user) => {
    const words = user.split(' ');

    const fisrtWord = words[0];
    const lastWord = words[words.length - 1];
    console.log(words, 'Package is loaded');
    const capitalizeWords = (
      fisrtWord.substring(0, 1) + lastWord.substring(0, 1)
    ).toUpperCase();

    return capitalizeWords ?? 'U';
  };

  //open the pop pu window of chat/bot
  const openPopup = () => {
    setIsOpen(!isOpen);
    setIsButtonClicked(!isButtonClicked);
  };

  //Open the maximize view and colaps
  const openMaximizeView = () => {
    const params = new URLSearchParams(window.location.search);
    let newMView;
    if (mView) {
      params.delete('view');
      newMView = false;
    } else {
      params.set('view', 'm');
      newMView = true;
    }
    const newParams = params.toString();
    const newUrl =
      window.location.pathname + (newParams ? `?${newParams}` : '');
    window.history.replaceState(null, '', newUrl);

    setMView(newMView);
  };

  //send the message when enter or button or send icon pressed
  const sendMessage = (message, isEvent) => {
    if (message !== '' && message !== null) {
      const newMessage = {
        msgre: message,
        message: 'user',
        action: false,
        time: calculateTime(),
      };

      setMessages((prevMessages) => [...prevMessages, newMessage]);
      setMessage('');

      setIsLoading(!isLoading);
      const newLoadingMessage = {
        message: 'admin',
        action: false,
        loading: true,
        isAuthorizedUser: true,
      };

      setMessages((prevMessages) => [...prevMessages, newLoadingMessage]);

      sendRequest(message, false);
    }
  };

  //send the request to process to as a checkpoint
  const sendRequest = (requestMessage, isEvent) => {
    processResponse('endpointcall', requestMessage);
  };

  //process the response handle any pre processing before call the api
  const processResponse = (callpoint, message) => {
    readDataAsStream(message);
  };

  //To remove or slice the messages that have loading critiria
  const checkAndRemoveLoadingMessage = () => {
    setIsLoading(!isLoading);
    setMessages((prevMessages) => prevMessages.slice(0, -1));
  };

  //Check to scroll to bottom of the page
  const scrollToBottom = () => {
    if (myScrollContainer.current) {
      myScrollContainer.current.scrollTop =
        myScrollContainer.current.scrollHeight;
    }
  };

  //when enter press hanle the key press to send message
  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !isLoading && isAuthorizedUser) {
      sendMessage(message, false);
      setMessage(''); // Call sendMessage function when "Enter" is pressed
    }
  };

  //Calculate the time
  const calculateTime = () => {
    const currentTime = new Date();
    const hours = currentTime.getHours();
    const minutes = currentTime.getMinutes();
    const period = hours >= 12 ? 'PM' : 'AM';

    const formattedHours = hours % 12 === 0 ? 12 : hours % 12;
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
    const formattedTime = `${formattedHours} : ${formattedMinutes} ${period}`;

    return formattedTime;
  };

  //format the response with bullets if it have a sturcture
  const formatTextWithBullets = (text) => {
    const principles = text.split('\n');
    return principles
      .map((principle, index) =>
        index > 0 ? `<br>${principle}` : `${principle}`
      )
      .join('\n');
  };

  //When Selecting the KPI then poping a message
  const selectKpi = (kpiValue, isEvent) => {
    setKpiValue(kpiValue);
    setPlaceholderValue(
      `Type your queries on ${kpiValue}, To change kpi type "Kpi" or "Hi"`
    );

    const newKpiSelectMessage = {
      msgre: ' ',
      message: 'admin',
      action: false,
      time: calculateTime(),
      kpi: false,
      kpiVal: kpiValue,
      isAuthorizedUser: true,
    };

    setMessages((prevMessages) => [...prevMessages, newKpiSelectMessage]);
    typingAnimation(
      `You selected the KPI value as ${kpiValue}`,
      messages.length
    );
  };

  //get the data and read data as stream and other functions with api
  const readDataAsStream = async (message) => {
    let responseData = '';
    let isMessagePushed = false;
    let messageIndex = 0;
    const userInfo = JSON.parse(localStorage.getItem('userInfo'));
    console.log('#####', userInfo);
    const userNameToChatAPI = userInfo.email;
    const apiBody = {
      user_query: message,
      username: userNameToChatAPI.split('@')[0],
      kpi: kpiValue,
      Authorization: localStorage.getItem(Token),
    };

    const options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(apiBody),
    };

    try {
      const response = await fetch(ApiUrl, options);

      if (!response.ok || response.body === null) {
        console.log('Response failed on stream', response);

        checkAndRemoveLoadingMessage();
        const responseErrorMessage = `We apologize for the inconvenience! It seems there's a timeout issue at the moment. Please try again later. If the problem persists, it could be due to an internal server error. Rest assured, we're working to resolve this issue promptly. Thank you for your patience!`;

        const botMessage = {
          msgre: '',
          message: 'admin',
          action: false,
          time: calculateTime(),
          image: false,
          imageLink: '/assets/graph.jpg',
          link: false,
          links: [],
          button: false,
          buttons: [],
          table: false,
          tableData: [],
          showAllRows: false,
          animationDone: false,
          kpiValues: [],
          kpi: false,
          kpiVal: kpiValue,
          isAuthorizedUser: true,
        };

        setMessages((prevMessages) => [...prevMessages, botMessage]);

        typingAnimation(responseErrorMessage, messages.length + 1);

        setIsLoading(false);
        return;
      }

      const reader = response.body.getReader();
      checkAndRemoveLoadingMessage();

      while (true) {
        const { done, value } = await reader.read();

        if (done) {
          responseData += new TextDecoder().decode(value);
          setIsLoading(false);
          break;
        }

        responseData += new TextDecoder().decode(value);

        let jsonData = responseData.trim();
        if (jsonData.startsWith('{') && jsonData.endsWith('}')) {
          let data = JSON.parse(responseData);

          if (data.kpi) {
            const Kpibuttons = data.kpivalues.map((kpiValue) => ({
              button: kpiValue,
              buttonName: kpiValue, // Assuming button name is the same as kpiValue
            }));

            const botKpiMessage = {
              msgre: '',
              message: 'admin',
              action: false,
              time: calculateTime().toString(),
              button: false,
              buttons: [],
              kpiValues: Kpibuttons,
              kpi: true,
              kpiVal: kpiValue,
              isAuthorizedUser: true,
            };

            setMessages((prevMessages) => [...prevMessages, botKpiMessage]);

            typingAnimation(data.bot_response, messages.length + 1);
          } else if (data.table_response) {
            const tableDataResponseFromApi = {
              header: data.column_names,
              body: data.result_set,
            };

            const responseMessage = data.bot_response;

            const botTableMessage = {
              msgre: '',
              message: 'admin',
              action: false,
              time: calculateTime(),
              image: false,
              imageLink: '/assets/graph.jpg',
              link: false,
              links: [],
              button: false,
              buttons: [],
              table: true,
              tableData: tableDataResponseFromApi,
              showAllRows: false,
              animationDone: false,
              kpiValues: [],
              kpi: false,
              kpiVal: kpiValue,
              isAuthorizedUser: true,
              showSqlQuery: false,
              sqlQuery: data.sql_query,
              visibleRows: 5,
              currentPage: 1,
              recordsPerPage: 5,
              totalRecords: tableDataResponseFromApi.body.length,
            };

            setMessages((prevMessages) => [...prevMessages, botTableMessage]);

            typingAnimation(responseMessage, messages.length + 1);
          } else {
            const responseMessage = data.bot_response;

            const botMessage = {
              msgre: '',
              message: 'admin',
              action: false,
              time: calculateTime(),
              image: false,
              imageLink: '/assets/graph.jpg',
              link: false,
              links: [],
              button: false,
              buttons: [],
              table: false,
              tableData: [],
              showAllRows: false,
              animationDone: false,
              kpiValues: [],
              kpi: false,
              kpiVal: kpiValue,
              isAuthorizedUser: true,
            };

            setMessages((prevMessages) => [...prevMessages, botMessage]);

            typingAnimation(responseMessage, messages.length + 1);
          }
        } else {
          if (
            responseData === '"Unauthorized user"\n' ||
            responseData === '"Invalid Token"\n'
          ) {
            setIsAutherizedUser(false);

            const responseMessage = `${formatTextWithBullets(
              responseData
            )}, Resetting the token and credentials`;

            const botUnauthorizedInvalidMessage = {
              msgre: '',
              message: 'admin',
              action: false,
              time: calculateTime(),
              image: false,
              imageLink: '/assets/graph.jpg',
              link: false,
              links: [],
              button: false,
              buttons: [],
              table: false,
              tableData: [],
              showAllRows: false,
              animationDone: false,
              kpiValues: [],
              kpi: false,
              kpiVal: kpiValue,
              isAuthorizedUser: false,
            };

            setMessages((prevMessages) => [
              ...prevMessages,
              botUnauthorizedInvalidMessage,
            ]);

            typingAnimation(responseMessage, messages.length + 1);

            resetTheValidToken();
          } else {
            if (!isMessagePushed) {
              const botStreamingMessage = {
                msgre: formatTextWithBullets(responseData),
                message: 'admin',
                action: false,
                time: calculateTime(),
                isAuthorizedUser: true,
                kpiValues: [],
                kpi: false,
                kpiVal: kpiValue,
              };

              setMessages((prevMessages) => [
                ...prevMessages,
                botStreamingMessage,
              ]);

              isMessagePushed = true;
              messageIndex = messages.length;
            } else {
              // eslint-disable-next-line
              setMessages((prevMessages) =>
                prevMessages.map((message, index) => {
                  if (index === messageIndex + 1) {
                    return {
                      ...message,
                      msgre: formatTextWithBullets(responseData),
                    };
                  } else {
                    return message;
                  }
                })
              );
            }
          }
        }
      }

      setIsLoading(false);
    } catch (err) {
      console.log('Error', err);
      // checkAndRemoveLoadingMessage();
      // setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  //Typeing animation to show looks typing or generating
  const typingAnimation = (str, msgIndex) => {
    let displayText = '';
    let words = str.split(' ');
    let currentIndex = 0;
    const lastMessageIndex = msgIndex;
    const intervalId = setInterval(() => {
      if (currentIndex < words.length) {
        displayText += words[currentIndex] + ' ';
        setMessages((prevMessages) =>
          prevMessages.map((message, index) => {
            if (index === lastMessageIndex) {
              return { ...message, msgre: displayText };
            } else {
              return message;
            }
          })
        );
        currentIndex++;
      } else {
        clearInterval(intervalId);
        setMessages((prevMessages) =>
          prevMessages.map((message, index) => {
            if (index === lastMessageIndex) {
              return { ...message, animationDone: true };
            } else {
              return message;
            }
          })
        );
      }
    }, 100);
  };

  //export to excel from available table of message function
  const exportToExcel = (tableData, kpiVal, time) => {
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet([tableData.header, ...tableData.body]);
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(
      wb,
      `exportedData_${kpiVal}_${new Date().getUTCDate()}.xlsx`
    );
  };

  return (
    <div>
      <button
        className='fixed bottom-8 right-8 bg-[#171C8F] hover:bg-[#171C8F] text-[#FEFEFE] font-bold py-2 px-4 rounded-full h-16 w-16 flex items-center justify-center z-[999]'
        onClick={openPopup}
      >
        {isButtonClicked && isOpen ? (
          <svg
            xmlns='http://www.w3.org/2000/svg'
            fill='none'
            viewBox='0 0 24 24'
            strokeWidth={1.5}
            stroke='currentColor'
            className='w-6 h-6'
          >
            <path
              strokeLinecap='round'
              strokeLinejoin='round'
              d='M6 18 18 6M6 6l12 12'
            />
          </svg>
        ) : (
          <svg
            xmlns='http://www.w3.org/2000/svg'
            fill='none'
            viewBox='0 0 24 24'
            strokeWidth={1.5}
            stroke='currentColor'
            className='w-6 h-6'
          >
            <path
              strokeLinecap='round'
              strokeLinejoin='round'
              d='M12 20.25c4.97 0 9-3.694 9-8.25s-4.03-8.25-9-8.25S3 7.444 3 12c0 2.104.859 4.023 2.273 5.48.432.447.74 1.04.586 1.641a4.483 4.483 0 0 1-.923 1.785A5.969 5.969 0 0 0 6 21c1.282 0 2.47-.402 3.445-1.087.81.22 1.668.337 2.555.337Z'
            />
          </svg>
        )}
      </button>

      {isOpen && (
        <div
          className={`fixed flex flex-col bg-white rounded-3xl z-[1000] ${
            mView ? 'inset-0' : 'bottom-32 right-8  shadow-md w-3/5 h-2/3'
          }`}
        >
          <div className='flex justify-between items-center bg-[#171C8F] px-4 py-2 rounded-t-xl h-16 text-[#FEFEFE]'>
            <div className='flex items-center'>
              <img
                src={MainIcon}
                alt='logo'
                className='mr-2 h-6 rounded-full'
              />
            </div>
            <div className='flex items-center space-x-4'>
              <button
                className='text-xl text-[#FEFEFE] hover:text-[#97999B] rounded-full ml-auto'
                onClick={openMaximizeView}
              >
                {mView ? (
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    fill='none'
                    viewBox='0 0 24 24'
                    strokeWidth={1.5}
                    stroke='currentColor'
                    className='w-8 h-8'
                  >
                    <path
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      d='M9 9V4.5M9 9H4.5M9 9 3.75 3.75M9 15v4.5M9 15H4.5M9 15l-5.25 5.25M15 9h4.5M15 9V4.5M15 9l5.25-5.25M15 15h4.5M15 15v4.5m0-4.5 5.25 5.25'
                    />
                  </svg>
                ) : (
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    fill='none'
                    viewBox='0 0 24 24'
                    strokeWidth={1.5}
                    stroke='currentColor'
                    className='w-6 h-6'
                  >
                    <path
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      d='M3.75 3.75v4.5m0-4.5h4.5m-4.5 0L9 9M3.75 20.25v-4.5m0 4.5h4.5m-4.5 0L9 15M20.25 3.75h-4.5m4.5 0v4.5m0-4.5L15 9m5.25 11.25h-4.5m4.5 0v-4.5m0 4.5L15 15'
                    />
                  </svg>
                )}
              </button>
            </div>
          </div>
          <div
            className='p-4 flex flex-col overflow-y-auto h-full'
            ref={myScrollContainer}
          >
            <div className='flex'>
              <div className='h-full w-full'>
                <ul>
                  {messages.map((msg, index) => (
                    <li key={index}>
                      {msg.message === 'admin' &&
                        (msg.msgre || msg.loading) &&
                        !msg.action && (
                          <div className='clear-both flex items-start mb-2'>
                            <img
                              src={BotIcon}
                              alt='botImage'
                              className='mr-4 w-8 h-8 rounded-full'
                            />

                            {/* loading message */}
                            {msg.loading && (
                              <div className='flex flex-col space-y-1 mr-5 w-10/12'>
                                <div className='flex space-x-2 items-start bg-white pt-4'>
                                  <span className='sr-only'>Loading...</span>
                                  <div className='h-2 w-2 bg-[#97999B] rounded-full animate-bounce [animation-delay:-0.3s]'></div>
                                  <div className='h-2 w-2 bg-black rounded-full animate-bounce [animation-delay:-0.5s]'></div>
                                  <div className='h-2 w-2 bg-[#97999B] rounded-full animate-bounce'></div>
                                </div>
                              </div>
                            )}
                            {!msg.loading && (
                              <div className='flex flex-col space-y-1 mr-5 w-10/12'>
                                <div
                                  className={`bg-white p-2 rounded-md text-base break-words border border-2 border-[#171C8F] font-roboto w-fit ${
                                    !msg.isAuthorizedUser
                                      ? 'text-red-500'
                                      : 'text-[#171C8F]'
                                  }`}
                                >
                                  {' '}
                                  {msg.msgre}{' '}
                                </div>

                                {/* image link of as message for show image */}
                                {msg.image && (
                                  <div className='border border-2 border-[#171C8F] rounded-md font-roboto'>
                                    <img
                                      src={msg.imageLink}
                                      alt='GraphImage'
                                      className='mr-4 w-full max-w-2xl h-auto rounded-md'
                                    />
                                  </div>
                                )}

                                {/* links as message */}
                                {msg.link && (
                                  <div>
                                    {msg.links.map((item, linkIndex) => (
                                      <div
                                        key={linkIndex}
                                        className='border border-2 border-[#171C8F] rounded-md flex items-center mb-1 w-fit font-roboto'
                                      >
                                        <a
                                          href={item.link}
                                          target='_blank'
                                          rel='noopener noreferrer'
                                          className='flex items-center hover:text-blue-500 hover:underline transition-all'
                                        >
                                          <svg
                                            xmlns='http://www.w3.org/2000/svg'
                                            fill='none'
                                            viewBox='0 0 24 24'
                                            strokeWidth={1.5}
                                            stroke='currentColor'
                                            className='w-6 h-6'
                                          >
                                            <path
                                              strokeLinecap='round'
                                              strokeLinejoin='round'
                                              d='M13.19 8.688a4.5 4.5 0 0 1 1.242 7.244l-4.5 4.5a4.5 4.5 0 0 1-6.364-6.364l1.757-1.757m13.35-.622 1.757-1.757a4.5 4.5 0 0 0-6.364-6.364l-4.5 4.5a4.5 4.5 0 0 0 1.242 7.244'
                                            />
                                          </svg>

                                          <span className='mr-4'>
                                            {item.linkService}
                                          </span>
                                        </a>
                                      </div>
                                    ))}
                                  </div>
                                )}

                                {/* buttons as kpi */}
                                {!msg.button &&
                                  msg.animationDone &&
                                  msg.kpi && (
                                    <div className='flex flex-wrap w-full'>
                                      {msg.kpiValues.map(
                                        (item, buttonIndex) => (
                                          <button
                                            key={buttonIndex}
                                            onClick={() =>
                                              !isLoading &&
                                              isAuthorizedUser &&
                                              selectKpi(item.button, false)
                                            }
                                            className='border border-2 border-[#171C8F] text-[#171C8F] rounded-md p-2 mr-1 mb-1 transition-all hover:bg-[#171C8F] hover:text-[#FEFEFE] focus:bg-[#171C8F] focus:text-[#FEFEFE] font-roboto'
                                          >
                                            {item.buttonName}
                                          </button>
                                        )
                                      )}
                                    </div>
                                  )}

                                {/* buttons as messsage */}
                                {msg.button &&
                                  msg.animationDone &&
                                  !msg.kpi && (
                                    <div className='flex flex-wrap w-full'>
                                      {msg.buttons.map((item, buttonIndex) => (
                                        <button
                                          key={buttonIndex}
                                          onClick={() =>
                                            !isLoading &&
                                            isAuthorizedUser &&
                                            sendMessage(item.button, false)
                                          }
                                          className='border border-2 border-[#171C8F] rounded-md p-2 mr-1 mb-1 transition-all hover:bg-[#171C8F] hover:text-[#FEFEFE] focus:bg-[#171C8F] focus:text-[#FEFEFE] font-roboto'
                                        >
                                          {item.buttonName}
                                        </button>
                                      ))}
                                    </div>
                                  )}

                                {msg.table && msg.animationDone && (
                                  <div
                                    className={`bg-blue-50 p-1 rounded-md text-base break-word border border-2 border-[#171C8F] overflow-x-auto no-scrollbar font-roboto  `}
                                  >
                                    <div className='flex flex-row justify-between mb-1'>
                                      <div className='flex justify-end items-center mr-2'>
                                        <span className='text-sm text-[#1C1C8F] italic bold'>
                                          {'KPI: '}
                                          {msg.kpiVal}
                                        </span>
                                      </div>
                                      <div className='flex justify-end items-center ml-2'>
                                        <span
                                          className='text-sm text-[#97999B] cursor-pointer hover:underline'
                                          onClick={() =>
                                            exportToExcel(
                                              msg.tableData,
                                              msg.kpiVal,
                                              msg.time
                                            )
                                          }
                                        >
                                          Export to Excel
                                        </span>
                                      </div>
                                    </div>
                                    <div className='max-h-96 overflow-y-auto'>
                                      <table
                                        className={`border border-[#171C8F] dark:border-[#171C8F] md:rounded-lg rounded break-word w-full`}
                                      >
                                        <thead className='sticky top-0'>
                                          <tr>
                                            {msg.tableData.header.map(
                                              (column, columnIndex) => (
                                                <th
                                                  key={columnIndex}
                                                  className='bg-blue-900 border border-black p-2 text-[#FEFEFE]'
                                                >
                                                  {column}
                                                </th>
                                              )
                                            )}
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {msg.tableData.body
                                            .slice(
                                              (msg.currentPage - 1) *
                                                msg.recordsPerPage,
                                              msg.currentPage *
                                                msg.recordsPerPage
                                            )
                                            .map((rowItem, rowIndex) => (
                                              <tr
                                                key={rowIndex}
                                                className='text-blue-800 hover:bg-blue-300 hover:text-[#FEFEFE]'
                                              >
                                                {rowItem.map(
                                                  (cellItem, columnIndex) => (
                                                    <td
                                                      key={columnIndex}
                                                      className='border border-black p-2'
                                                    >
                                                      <p>{cellItem}</p>
                                                    </td>
                                                  )
                                                )}
                                              </tr>
                                            ))}
                                        </tbody>
                                      </table>
                                    </div>

                                    <div className='flex flex-col'>
                                      <div className='flex flex-row justify-between'>
                                        <div className='flex justify-start items-center mt-2'>
                                          <span className='text-sm text-[#97999B] cursor-pointer hover:underline'>
                                            Showing:{' '}
                                            {Math.min(
                                              5 * (msg.currentPage - 1) + 1,
                                              msg.totalRecords
                                            )}{' '}
                                            {' - '}
                                            {Math.min(
                                              5 * msg.currentPage,
                                              msg.totalRecords
                                            )}{' '}
                                            of {msg.totalRecords} {'Records'}
                                          </span>
                                        </div>
                                        <div className='flex justify-end items-center mt-2'>
                                          {/* {!msg.showSqlQuery &&
                                            msg.sqlQuery.length > 0 && (
                                              <span
                                                className="ml-2 text-sm text-[#97999B] cursor-pointer hover:underline"
                                                onClick={() =>
                                                  setMessages((prev) =>
                                                    prev.map((m) =>
                                                      m === msg
                                                        ? {
                                                            ...m,
                                                            showSqlQuery: true,
                                                          }
                                                        : m
                                                    )
                                                  )
                                                }
                                              >
                                                Show SQL
                                              </span>
                                            )}
                                          {msg.showSqlQuery &&
                                            msg.sqlQuery.length > 0 && (
                                              <span
                                                className="ml-2 text-sm text-[#97999B] cursor-pointer hover:underline"
                                                onClick={() =>
                                                  setMessages((prev) =>
                                                    prev.map((m) =>
                                                      m === msg
                                                        ? {
                                                            ...m,
                                                            showSqlQuery: false,
                                                          }
                                                        : m
                                                    )
                                                  )
                                                }
                                              >
                                                Hide SQL
                                              </span>
                                            )} */}

                                          {msg.currentPage > 1 && (
                                            <span
                                              className='ml-2 text-sm text-[#97999B] cursor-pointer hover:underline'
                                              onClick={() =>
                                                setMessages((prev) =>
                                                  prev.map((m) =>
                                                    m === msg
                                                      ? {
                                                          ...m,
                                                          currentPage:
                                                            m.currentPage - 1,
                                                        }
                                                      : m
                                                  )
                                                )
                                              }
                                            >
                                              Previous
                                            </span>
                                          )}
                                          {msg.totalRecords >
                                            msg.currentPage *
                                              msg.recordsPerPage && (
                                            <span
                                              className='ml-2 text-sm text-[#97999B] cursor-pointer hover:underline'
                                              onClick={() =>
                                                setMessages((prev) =>
                                                  prev.map((m) =>
                                                    m === msg
                                                      ? {
                                                          ...m,
                                                          currentPage:
                                                            m.currentPage + 1,
                                                        }
                                                      : m
                                                  )
                                                )
                                              }
                                            >
                                              Next
                                            </span>
                                          )}
                                        </div>
                                      </div>

                                      {msg.showSqlQuery && (
                                        <div className='flex justify-start items-center mt-2 bg-white rounded-md'>
                                          <span className='font-roboto break-words text-base text-[#171C8F] italic ml-2 mr-2'>
                                            {' '}
                                            {msg.sqlQuery}{' '}
                                          </span>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                )}

                                {/* Subsequent messages or time */}
                                {msg.animationDone && (
                                  <div className='text-xs py-1 rounded-md text-blue-700 font-roboto'>
                                    {msg.time}
                                  </div>
                                )}
                                {/* Add more message divs as needed */}
                              </div>
                            )}
                          </div>
                        )}
                      {msg.message === 'user' && (
                        <div className='clear-both flex justify-end items-end mb-2'>
                          <div className='flex flex-col space-y-1 items-end ml-5 w-10/12'>
                            <div className='bg-[#171C8F] p-2 rounded-md text-base text-[#FEFEFE] break-all border border-2 border-[#171C8F] font-roboto'>
                              {' '}
                              {msg.msgre}{' '}
                            </div>

                            {/* Subsequent messages or time */}
                            <div className='text-xs py-1 rounded-md text-right text-blue-700 font-roboto'>
                              {msg.time}
                            </div>
                            {/* Add more message divs as needed */}
                          </div>

                          <div className='ml-4 self-start inline-flex items-center justify-center w-10 h-10 overflow-hidden bg-blue-400 rounded-full dark:bg-blue-400 border-2 border-[#171C8F]'>
                            <span className='font-medium text-blue-700 dark:text-blue-700'>
                              {userLetters}
                            </span>
                          </div>
                        </div>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
          <div className='bg-blue-50 px-4 py-2 flex-shrink-0 rounded-b-xl h-16'>
            <div className='flex'>
              <input
                type='text'
                className='border border-[#171C8F] px-2 py-1 rounded-lg mr-2 w-full h-12 font-roboto text-lg'
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                onKeyPress={handleKeyPress}
                placeholder={placeholderValue}
                maxLength={2000}
              />
              <div className='flex flex-col items-center w-20'>
                <button
                  className='hover:bg-[#171C8F] hover:text-[#FEFEFE] text-black font-bold pt-1 px-2 rounded'
                  onClick={() =>
                    !isLoading &&
                    isAuthorizedUser &&
                    sendMessage(message, false)
                  }
                >
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    fill='none'
                    viewBox='0 0 24 24'
                    strokeWidth={1.5}
                    stroke='currentColor'
                    className='w-6 h-6'
                  >
                    <path
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      d='M6 12 3.269 3.125A59.769 59.769 0 0 1 21.485 12 59.768 59.768 0 0 1 3.27 20.875L5.999 12Zm0 0h7.5'
                    />
                  </svg>
                </button>
                <div>
                  <span className='text-xs text-[#97999B] justify-center items-center'>
                    {message.length}/2000
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
